import { simpleSet } from '@r/reducers/utils';

const setCalculationModeSameAsCustomerAddress = simpleSet as
  redux.reducers.calculationMode.settings.information.sameAsCustomerAddress;

export const sameAsCustomerAddress = setCalculationModeSameAsCustomerAddress(
  'SET_CALCULATION_MODE_SAME_AS_CUSTOMER_ADDRESS',
  false
);
